'use client';

import { useMounted } from '@flipster/react/misc/lifecycle/mount';
import { css } from '@flipster/styled-system/css';

import { OrderbookHeader } from './OrderbookHeader';
import { OrderbookList } from './OrderbookList';
import { OrderbookRatioBar } from './OrderbookRatioBar';

// 데이터 계산은 전부 orderbookDataBunja(./bunja.ts)에 있고, 하위 컴포넌트가 각자 consume한다
export const Orderbook = () => {
  const isMounted = useMounted();

  return (
    <section
      className={css({
        gridArea: 'orderbook',
        rounded: 'var(--grid-rounded)',
        bg: 'background.default.level-0',
        tabletDown: { display: 'none' },
        display: 'flex',
        flexDirection: 'column',
        overflow: { base: 'hidden', tablet: 'visible' },
        h: { base: 594, tablet: '100%' },
        pt: 12,
        pb: 16,
      })}
    >
      <OrderbookHeader />
      {isMounted && (
        <>
          <OrderbookList />
          <OrderbookRatioBar />
        </>
      )}
    </section>
  );
};
